// src/App.js
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import MainPage from "./pages/MainPage";
import QrPage from "./pages/QrPage";
import WatermarkPage from "./pages/WatermarkPage";
import ExifPage from "./pages/EXIF/EXIFPage";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Base64Page from "./pages/base64Page";

import MainPage_en from "./pages/en/MainPage_en";
import MainPage_ja from "./pages/ja/MainPage_ja";
import MainPage_tw from "./pages/tw/MainPage_tw";

import EXIFPageEn from "./pages/en/EXIFPage_en";
import EXIFPageJA from "./pages/ja/EXIFPage_ja";
import EXIFPageTW from "./pages/tw/EXIFPage_tw";

import Base64PageJA from "./pages/ja/base64Page_ja";
import Base64PageEN from "./pages/en/base64Page_en";
import Base64PageTW from "./pages/tw/base64Page_tw";

import WatermarkPageEn from "./pages/en/WatermarkPage_en";
import WatermarkPageJa from "./pages/ja/WatermarkPage_ja";
import WatermarkPageTw from "./pages/tw/WatermarkPage_tw";

import QrPageEN from "./pages/en/QrPage_en";
import QrPageJA from "./pages/ja/QrPage_ja";
import QrPageTW from "./pages/tw/QrPage_tw";

import PrivacyJA from "./pages/ja/Privacy_ja";
import PrivacyEN from "./pages/en/Privacy_en";
import PrivacyTW from "./pages/tw/Privacy_tw";

import TermsEN from "./pages/en/Terms_en";
import TermsJA from "./pages/ja/Terms_ja";
import TermsTW from "./pages/tw/Terms_tw";

function App() {
  // ✅ AdFit 스크립트 전역 1회 로드
  useEffect(() => {
    if (window.__adfitLoaded) return;
    window.__adfitLoaded = true;

    const script = document.createElement("script");
    script.src = "//t1.daumcdn.net/kas/static/ba.min.js";
    script.async = true;
    script.type = "text/javascript";

    document.body.appendChild(script);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/qr" element={<QrPage />} />
        <Route path="/watermark" element={<WatermarkPage />} />
        <Route path="/aiexif" element={<ExifPage />} />
        <Route path="/base64" element={<Base64Page />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        <Route path="/en" element={<MainPage_en />} />
        <Route path="/ja" element={<MainPage_ja />} />
        <Route path="/tw" element={<MainPage_tw />} />

        <Route path="/en/aiexif" element={<EXIFPageEn />} />
        <Route path="/ja/aiexif" element={<EXIFPageJA />} />
        <Route path="/tw/aiexif" element={<EXIFPageTW />} />

        <Route path="/ja/base64" element={<Base64PageJA />} />
        <Route path="/en/base64" element={<Base64PageEN />} />
        <Route path="/tw/base64" element={<Base64PageTW />} />

        <Route path="/en/watermark" element={<WatermarkPageEn />} />
        <Route path="/ja/watermark" element={<WatermarkPageJa />} />
        <Route path="/tw/watermark" element={<WatermarkPageTw />} />

        <Route path="/en/qr" element={<QrPageEN />} />
        <Route path="/ja/qr" element={<QrPageJA />} />
        <Route path="/tw/qr" element={<QrPageTW />} />

        <Route path="/ja/privacy" element={<PrivacyJA />} />
        <Route path="/en/privacy" element={<PrivacyEN />} />
        <Route path="/tw/privacy" element={<PrivacyTW />} />

        <Route path="/en/terms" element={<TermsEN />} />
        <Route path="/ja/terms" element={<TermsJA />} />
        <Route path="/tw/terms" element={<TermsTW />} />
      </Routes>
    </Router>
  );
}

export default App;
